/**
 * Parses the html for a modal window
 * @param {string} html - representing the HTML of the modal window
 *
 * @return {Object} - Object with properties body, image, and header.
 */
function parseHtml(html) {
    var $html = $("<div>").append($.parseHTML(html));

    var header = $html.find(".modal-header");
    var image = $html.find(".modal-image");
    var body = $html.find(".product-wrapper");

    return { header: header, image: image, body: body };
}

/**
 * replaces the content in the modal window on for the selected product variation.
 * @param {string} selectedValueUrl - url to be used to retrieve a new product model
 */
function fillModalElement(selectedValueUrl) {
    $("#workroomDetailsModal .modal-body").spinner().start();
    $.ajax({
        url: selectedValueUrl,
        method: "GET",
        success: function (data) {
            var parsedHtml = parseHtml(data);

            $("#workroomDetailsModal .modal-body, #workroomDetailsModal .modal-header").empty();
            $("#workroomDetailsModal .modal-header").replaceWith(parsedHtml.header);
            $("#workroomDetailsModal .modal-image").replaceWith(parsedHtml.image);
            $("#workroomDetailsModal .modal-body").html(parsedHtml.body);
            $("#workroomDetailsModal").modal("show");

            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
    if ($("#workroomDetailsModal").length !== 0) {
        $("#workroomDetailsModal").remove();
    }
    var htmlString = "<!-- Modal -->"
        + "<div class='modal fade material-details-modal' id='workroomDetailsModal' role='dialog'>"
        + "<span class='enter-message sr-only' ></span>"
        + "<div class='modal-dialog'>"
        + "<!-- Modal content-->"
        + "<div class='modal-content'>"
        + "<div class='modal-header'>"
        + "    <button type='button' class='close' data-dismiss='modal' aria-label='Close'>&nbsp;</button>"
        + "</div>"
        + "<div class='modal-image'></div>"
        + "<div class='modal-body'></div>"
        + "</div>"
        + "</div>"
        + "</div>";
    $("body").append(htmlString);
}

module.exports = {
    parseHtml: parseHtml,
    fillModalElement: fillModalElement,
    getModalHtmlElement: getModalHtmlElement
};
